import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Resources', path: '/resources' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo/Brand */}
          <Link to="/" className="flex-shrink-0">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-lg flex items-center justify-center text-white font-bold text-xl">
                MZ
              </div>
              <div className="hidden md:block">
                <h1 className="text-lg font-bold text-slate-900 leading-tight">
                  Maulana Zubair Divine
                </h1>
                <p className="text-xs text-slate-600">School of Motoring (DSM)</p>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-emerald-600 border-b-2 border-emerald-600'
                    : 'text-slate-700 hover:text-emerald-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Contact Buttons - Desktop */}
          <div className="hidden lg:flex items-center gap-3">
            <a href="tel:07834618908">
              <Button size="sm" variant="outline" className="border-emerald-600 text-emerald-600 hover:bg-emerald-50">
                <Phone className="mr-2 h-4 w-4" />
                Call
              </Button>
            </a>
            <a href="mailto:zubairapabhai@gmail.com">
              <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white">
                <Mail className="mr-2 h-4 w-4" />
                Email
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-slate-700 hover:text-emerald-600"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-base font-medium py-2 px-4 rounded-lg transition-colors duration-200 ${
                    isActive(link.path)
                      ? 'bg-emerald-50 text-emerald-600'
                      : 'text-slate-700 hover:bg-slate-50'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <div className="flex flex-col gap-3 mt-4 px-4">
                <a href="tel:07834618908" onClick={() => setMobileMenuOpen(false)}>
                  <Button size="sm" variant="outline" className="w-full border-emerald-600 text-emerald-600 hover:bg-emerald-50">
                    <Phone className="mr-2 h-4 w-4" />
                    Call: 07834 618908
                  </Button>
                </a>
                <a href="mailto:zubairapabhai@gmail.com" onClick={() => setMobileMenuOpen(false)}>
                  <Button size="sm" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white">
                    <Mail className="mr-2 h-4 w-4" />
                    Email Us
                  </Button>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
